import { post } from '../util/fetchUtil';

export default async (puppeteerKey) => {
  const res = await post('/getGlobalVariables', { key: puppeteerKey });

  Object.entries(res).forEach(([key, value]) => {
    window[key] = value;
  });
};
